export {default as force} from './src/Force';



// WEBPACK FOOTER //
// ./~/vega-force/index.js